var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { UserService } from '../../../services/user.service';
import { InfluencerGroup, BulkUploadInfluencer } from '../../../../models/influencer-group';
import { InvalidAction, BlockedReason, WallType } from '../../../../models/user';
import { EventTrackerService, UserActionType, Page, TargetType, ActionSource, ActionDetails } from '../../../services/event-tracker/event-tracker.service';
import { BulkUploadInfluencerModalComponent } from './bulk-upload-influencer-modal/bulk-upload-influencer-modal.component';
import { CommonConstant } from '../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { ObjectUtils } from '../../../utils/object.utils';
import { InfluencerGroupsService } from '../../influencer-groups/influencer-groups.service';
var BulkUploadInfluencerComponent = /** @class */ (function () {
    function BulkUploadInfluencerComponent(modalService, userService, translate, influencerGroupsService, eventTracker) {
        this.modalService = modalService;
        this.userService = userService;
        this.translate = translate;
        this.influencerGroupsService = influencerGroupsService;
        this.eventTracker = eventTracker;
        this.hasSelectedInfluencers = false;
        this.closeBottomBarCallback = new EventEmitter();
        this.afterUploadBulkInfluencerEvent = new EventEmitter();
        this.temporaryHidden = false;
        this.bulkUploadInfluencer = new BulkUploadInfluencer();
    }
    BulkUploadInfluencerComponent.prototype.showBulkUploadInfluencerModal = function () {
        if (this.userService.isFreeUser()) {
            this.userService.doInvalidActionByLevel('Add to Group');
            this.trackUserInvalidAction();
        }
        else {
            this.closeBottomBarCallback.emit({
                isTemporaryHidden: true
            });
            this.bulkUploadInfluencerPopupRef = this.modalService.openInCenter(this.bulkUploadInfluencerPopup, null, 'campaign-confirm-popup');
        }
    };
    BulkUploadInfluencerComponent.prototype.beforeUploadBulkInfluencer = function () {
        this.modalService.closeSinglePopup(this.bulkUploadInfluencerPopupRef);
        this.showPopup(this.translate.instant('bulk_upload_influencer.modal.uploading_notification_title'), this.translate.instant('bulk_upload_influencer.modal.uploading_notification_content'));
        this.callService();
    };
    BulkUploadInfluencerComponent.prototype.closeBulkUploadInfluencerModal = function (evt) {
        // clean cached bulk influencer list
        this.bulkUploadInfluencer.influencers = [];
        this.bulkUploadInfluencer.shouldNotify = false;
        this.bulkUploadInfluencerModalComponent.bulkUploadInfluencerInputValue = null;
        this.closeBottomBarCallback.emit({
            bulkUploadInfluencers: evt,
            isTemporaryHidden: false
        });
        if (this.bulkUploadInfluencerPopupRef) {
            this.modalService.closeSinglePopup(this.bulkUploadInfluencerPopupRef);
        }
    };
    BulkUploadInfluencerComponent.prototype.showPopup = function (modelTitle, msgContent) {
        this.modelTitle = modelTitle;
        this.popupMessage = msgContent;
        this.modalService.open(this.bulkUploadNotificationPopup, null, true);
    };
    BulkUploadInfluencerComponent.prototype.callService = function () {
        var _this = this;
        var bulkUploadInfluencerData = ObjectUtils.deepClone(this.bulkUploadInfluencer);
        this.influencerGroupsService.uploadBulkInfluencer(this.influencerGroup.influencer_group_id, this.bulkUploadInfluencer).subscribe(function (res) {
            _this.sendMixpanelEvents(null);
            var message = _this.bulkUploadInfluencer.shouldNotify ? _this.translate.instant('bulk_upload_influencer.modal.success_with_notify') : _this.translate.instant('bulk_upload_influencer.modal.success_without_notify');
            _this.showPopup(_this.translate.instant('notification.success'), message);
            setTimeout(function () {
                _this.closeBulkUploadInfluencerModal(bulkUploadInfluencerData.influencers);
            }, CommonConstant.TRANSITION_TIME);
        }, function (error) {
            _this.bulkUploadInfluencerPopupRef = _this.modalService.openInCenter(_this.bulkUploadInfluencerPopup, null, 'campaign-confirm-popup');
            if (error && error.error && error.error.message) {
                _this.handleError(error.error);
            }
            else {
                _this.showPopup(_this.translate.instant('notification.error'), _this.translate.instant('bulk_upload_influencer.modal.api_failed'));
            }
        });
    };
    BulkUploadInfluencerComponent.prototype.handleError = function (error) {
        var errorMsg = this.translate.instant('bulk_upload_influencer.modal.api_general_error');
        var maxValue = this.userService.maxGroupInfluencers;
        this.showPopup(this.translate.instant('notification.error'), errorMsg);
        this.sendMixpanelEvents(this.influencerGroupsService.extractLimitInfoFromErrorMessage(errorMsg, this.bulkUploadInfluencer.influencers.length, maxValue, false));
    };
    BulkUploadInfluencerComponent.prototype.sendMixpanelEvents = function (limitInfo) {
        if (!limitInfo) {
            this.trackUserAction();
        }
        else {
            this.trackUserInvalidAction(limitInfo);
        }
    };
    BulkUploadInfluencerComponent.prototype.trackUserAction = function () {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
            id: this.influencerGroup.influencer_group_id,
            name: this.influencerGroup.influencer_group_name,
            type: TargetType.INFLUENCER_GROUP
        }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.BULK_UPLOAD }, this.influencerGroup), undefined, null, null);
    };
    BulkUploadInfluencerComponent.prototype.trackUserInvalidAction = function (limitInfo) {
        var detailAction;
        if (limitInfo) {
            detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
        }
        else {
            detailAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.FEATURE_UNAVAILABLE, 'Advanced Groups', false, null, null, this.userService.accountLevelName);
        }
        this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.INFLUENCER_GROUP, {
            id: this.influencerGroup.influencer_group_id,
            name: this.influencerGroup.influencer_group_name,
            type: TargetType.INFLUENCER_GROUP
        }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.BULK_UPLOAD }, this.influencerGroup), undefined, null, null);
    };
    return BulkUploadInfluencerComponent;
}());
export { BulkUploadInfluencerComponent };



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer.component.ts.pre-build-optimizer.js